<template>
  <a-layout>
    <a-space style="margin-top: 2px">
      <vxe-input v-model="query.no" clearable placeholder="business.label.no" size="small" type="search" @search-click="refresh"/>
      <vxe-input v-model="query.name" clearable placeholder="business.label.name" size="small" type="search" @search-click="refresh"/>
      <vxe-button content="button.refresh" icon="vxe-icon-refresh" size="mini" status="primary" @click="refresh"/>
      <vxe-button content="button.add" icon="vxe-icon-add" size="mini" status="primary" @click="add"/>
      <vxe-button content="button.save" icon="vxe-icon-save" size="mini" status="primary" @click="save"/>
    </a-space>
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :export-config="{}"
      ref="table"
      align="center"
      :data="data"
      :loading="loading"
      :keyboard-config="{isArrow: true}"
      :scroll-x="{enabled: true}"
      size="mini"
      :row-config="{isCurrent: true, isHover: true}"
      :column-config="{resizable: true}"
      keep-source
      :edit-rules="editRules"
      :edit-config="{ trigger: 'click', mode: 'cell', showStatus: true }"
      :height="height"
      style="margin-top: 2px">
      <vxe-column fixed="left" type="seq" width="40"/>
      <vxe-column :edit-render="{name:'VxeInput',autoSelect:true}" field="no" title="business.label.no"/>
      <vxe-column :edit-render="{name:'VxeInput',autoSelect:true}" field="name" title="business.label.name"/>
      <vxe-column :edit-render="{name:'VxeInput',autoSelect:true}" field="codeInitial" title="business.label.codeInitial"/>
      <vxe-column :edit-render="{name:'VxeNumberInput',autoSelect:true,props:{min:0}}" field="codeLength" title="business.label.codeLength"/>
      <vxe-column :edit-render="{name:'VxeNumberInput',autoSelect:true,props:{min:0}}" field="dimension.length" title="business.label.length"/>
      <vxe-column :edit-render="{name:'VxeNumberInput',autoSelect:true,props:{min:0}}" field="dimension.width" title="business.label.width"/>
      <vxe-column :edit-render="{name:'VxeNumberInput',autoSelect:true,props:{min:0}}" field="dimension.height" title="business.label.height"/>
      <vxe-column :edit-render="{name:'VxeNumberInput',autoSelect:true,props:{min:0}}" field="dimension.volume" title="business.label.volume"/>
      <vxe-column :edit-render="{name:'VxeNumberInput',autoSelect:true,props:{min:0}}" field="weight" title="business.label.weight"/>
      <vxe-column :edit-render="{name:'VxeNumberInput',autoSelect:true,props:{min:0}}" field="halfVolume" title="business.label.halfVolume"/>
      <vxe-column :cell-render="{name:'VxeSwitch'}" field="available" title="business.label.available" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch'}" field="physical" title="business.label.physical" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch'}" field="goback" title="business.label.goback" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch'}" field="sendingErp" title="business.label.sendingErp" width="70"/>
    </vxe-table>
    <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" size="mini" style="height: 24px" @page-change="pageChange"/>
  </a-layout>
</template>

<script>
import Vue from 'vue'
import { findAll, saveAll } from '@/api/Api'
import { ENTERPRISE, SCREEN_HEIGHT } from '@/store/mutation-types'
import { ContainerType } from '@/api/dto/common/ContainerType'

export default {
  name: 'ContainerTypeMaintain',
  data() {
    return {
      enterprise: Vue.ls.get(ENTERPRISE),
      loading: false,
      data: [],
      query: new ContainerType(),
      page: 1,
      size: 20,
      contentSize: 0,
      height: Vue.ls.get(SCREEN_HEIGHT) * (0.815),
      editRules: {
        no: [
          { required: true, type: 'string', message: '编号不能为空' }
        ],
        name: [
          { required: true, type: 'string', message: '名称不能为空' }
        ]
      }
    }
  },
  created() {
    this.refresh()
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    fetch() {
      this.loading = true
      findAll('containerTypeFactory', this.query, this.page, this.size).then(res => {
        if (res.success) {
          this.contentSize = res.contentSize
          this.data = res.result.map(item => {
            return new ContainerType(item)
          })
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    add() {
      this.data.push(new ContainerType())
    },
    async save() {
      const errMap = await this.$refs.table.validate(true)
      if (errMap) {
        return
      }
      let saveData = this.$refs.table.getUpdateRecords().concat(this.$refs.table.getInsertRecords())
      if (saveData.length > 0) {
        this.loading = true
        saveData = saveData.map(item => {
          item.enterprise = this.enterprise
          return item.toJSONObject()
        })
        saveAll('containerTypePersister', saveData).then(res => {
          if (res.success) {
            this.fetch()
            this.$message.success('保存成功')
          }
        }).finally(() => this.loading = false)
      } else {
        this.$message.warning('无数据可保存')
      }
    }
  }
}
</script>